/* global axios */
import ApiClient from './ApiClient';

class PortalListingSyncsAPI extends ApiClient {
  constructor() {
    super('portal_listing_syncs', { accountScoped: true });
  }

  list(params = {}) {
    return axios.get(this.url, { params });
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  poll(id, payload = {}) {
    return axios.post(`${this.url}/${id}/poll`, payload);
  }

  retry(id, payload = {}) {
    return axios.post(`${this.url}/${id}/retry`, payload);
  }

  reconcile(id, payload = {}) {
    return axios.post(`${this.url}/${id}/reconcile`, payload);
  }
}

export default new PortalListingSyncsAPI();
